import { PrevHeaderBarWithTitleTemplate } from '#templates';
import { Suspense } from 'react';
import styled from 'styled-components';

import LoadingSpinner from '#atoms/LoadingSpinner';
import { MemberInfo } from '../MemberInfo/components/MemberInfo';
import { RoundInfo } from '../RoundInfo/RoundInfo';
import { InfoSection } from '../components/InfoSection';
import { SaveButton } from '../components/SaveButton';
import { SendButton } from '../components/SendButton';
import { DraftChartExerciseMedia } from './ChartExerciseMedia/DarftChartExerciseMedia';
import { ChartFormEditExerciseList } from './ChartFormEditExerciseList';
import { DraftTrainerFeedback } from './DraftTrainerFeedback';

export const DashboardChartFormEditPage = () => (
  <PrevHeaderBarWithTitleTemplate
    rightContents={<SaveButton isEdit />}
    title="운동차트 수정"
    defaultBackground
  >
    <div className="h-217">
      <Suspense fallback={<LoadingSpinner />}>
        <InfoSection />
      </Suspense>
    </div>
    <Divider />

    <div className="px-20 pb-32 pt-8">
      <Suspense
        fallback={
          <div className="flex justify-center items-center">
            <LoadingSpinner />
          </div>
        }
      >
        <ChartFormEditExerciseList />
      </Suspense>
    </div>
    <Divider />
    <div className="px-20 pb-32">
      <DraftChartExerciseMedia />
    </div>
    <Divider />
    <div className="px-20 py-32">
      <Suspense
        fallback={
          <div className="h-610 w-full flex justify-center items-center">
            <LoadingSpinner />
          </div>
        }
      >
        <MemberInfo />
      </Suspense>

      <Suspense
        fallback={
          <div className="h-610 w-full flex justify-center items-center">
            <LoadingSpinner />
          </div>
        }
      >
        <RoundInfo />
      </Suspense>
    </div>
    <Divider />

    <DraftTrainerFeedback />

    <div className="pb-60" />

    <SendButton />
  </PrevHeaderBarWithTitleTemplate>
);

const Divider = styled.div`
  height: 8px;
  background: var(--bg-800, #1e1b24);
`;
